
import { ElektroonilineValve } from '@/models/ElektrooonilineValve';
import { AxiosTeenus } from './axios-teenus';

export class ElektroonilineValveTeenus {

    public async minuElektroonilineValveAjakava(): Promise<ElektroonilineValve[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<ElektroonilineValve[]>(`/api/elektroonilinevalve/evajakava`);

        return response?.data;
    }

    public async kinnitaElektroonilineValveAjakava(ajakavaId: number): Promise<ElektroonilineValve[]> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<ElektroonilineValve[]>(`/api/elektroonilinevalve/kinnita-evajakava/${ajakavaId}`);

        return response?.data;
    }
}